
export const ALLOCATION_PRIORITY_MAP = {
    "-1": "Low",
    "0": "Default",
    "1": "High"
}